<template>
    <div class="echo-state alert-danger" data-nosnippet :class="{'echo-state-visible': !$root.echoConnectedWihoutErrors}">
        <div>
            <header>
                <i class="fas fa-exclamation-triangle"></i> Mise à jour temps réel désactivée
                <span v-if="!$root.echoConnected">
                    : reconnexion au serveur <i class="fas fa-spinner fa-spin"></i>
                </span>
                <button v-else-if="$root.echoHasErrors" class="btn btn-danger" @click="deployed = !deployed">{{ deployed ? 'Cacher les détails' : 'Voir les détails' }}</button>
            </header>
            <ul class="list-group" :class="deployed ? 'deployed' : null">
                <li class="list-group-item list-group-item-danger" v-for="error in $root.echoErrors">
                    {{ error }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'EchoState',

        data() {
            return {
                deployed: false,
            };
        },
    }
</script>

<style scoped lang="scss">
.echo-state {
    display: none;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 9999;
    padding: 5px;

    &-visible {
        display: block;

        header {
            font-weight: bold;
        }

        ul {
            display: none;

            &.deployed {
                display: block;
            }
        }
    }
}
</style>
